import { render, staticRenderFns } from "./recommend-courtesy.vue?vue&type=template&id=308c44b2&scoped=true"
import script from "./recommend-courtesy.vue?vue&type=script&lang=js"
export * from "./recommend-courtesy.vue?vue&type=script&lang=js"
import style0 from "./recommend-courtesy.vue?vue&type=style&index=0&id=308c44b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c44b2",
  null
  
)

export default component.exports